<div id="app"><top-bar v-if="!isEmbeddedInIpadView"></top-bar><transition name="fade" mode="out-in"><router-view></router-view></transition></div>